const initialState = {
  online: window.navigator.onLine,
};

export default initialState;
